import React from 'react'
import classNames from 'classnames'
import BackgroundImage from 'gatsby-background-image'
import Container from '../container'
import Row from '../row'
import Col from '../col'
import ArrowLink from '../arrow-link'
import diagonalLG from '../../images/diagonal-pattern-large.svg'
import diagonalSlim from '../../images/diagonal-pattern-slim.svg'
import styles from './hero.module.scss'
import shared from '../shared.module.scss'

const Hero = ({
  // Hero Props
  title,
  subTitle,
  intro,
  link,
  linkText,
  linkNewTab,
  linkExternal,
  linkArrowType,
  linkArrowPosition,
  colSpan,
  backgroundImage,
  backgroundImageSize,
  backgroundImagePositionX,
  backgroundImagePositionY,

  // Section Props
  className,
  marginBottom,
  containerFluid,
  textColor,
  backgroundColor, 
}) => {
  const Inner = () => (
    <Container fluid={ containerFluid }>
      <div className={ styles.diagonalLG }>
        <img className={ styles.diagonal } src={ diagonalLG } alt={ title } />
      </div>

      <div className={ styles.diagonalSlim }>
        <img className={ styles.diagonal } src={ diagonalSlim } alt={ title } />
      </div>
      
      <Row>
        <Col lg={ colSpan || 9 } className={ styles.inner }>
          <h1 className={ styles.title }>{ title }</h1>

          { subTitle && (
            <div className={ styles.subTitle } dangerouslySetInnerHTML={{ __html: subTitle }} />
          )}

          { intro && (
            <div className={ styles.intro } dangerouslySetInnerHTML={{ __html: intro }} />
          )}

          { link && linkText && (
            <ArrowLink
              to={ link }
              text={ linkText }
              newTab={ linkNewTab }
              external={ linkExternal }
              arrowType={ linkArrowType }
              arrowPosition={ linkArrowPosition }
            />
          )}
        </Col>
      </Row>
    </Container>
  )

  if( backgroundImage ) {
    return (
      <BackgroundImage
        tag="section"
        fluid={ backgroundImage }
        backgroundColor={ backgroundColor }
        style={{ color: textColor }}
        className={ classNames( styles.hero, {
          [ shared.margin ]: marginBottom,
          [ styles.backgroundSizeCover ]: backgroundImageSize === 'cover',
          [ styles.backgroundSizeContain ]: backgroundImageSize === 'contain',
          [ styles.backgroundPositionXLeft ]: backgroundImagePositionX === 'left',
          [ styles.backgroundPositionXCenter ]: backgroundImagePositionX === 'center',
          [ styles.backgroundPositionXRight ]: backgroundImagePositionX === 'right',
          [ styles.backgroundPositionYTop ]: backgroundImagePositionY === 'top',
          [ styles.backgroundPositionYCenter ]: backgroundImagePositionY === 'center',
          [ styles.backgroundPositionYBottom ]: backgroundImagePositionY === 'bottom',
        }, className ) }
      >
        <Inner />
      </BackgroundImage>
    )
  }

  return (
    <section
      className={ classNames( styles.hero, marginBottom ? shared.margin : '', className ) }
      style={{ color: textColor, backgroundColor }}
    >
      <Inner />
    </section>
  )
}

export default Hero
